import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GlobalWrapper } from './reset.style';
import { SocketStatsBar } from 'src/domains/layouts/webview/components/socketStatsBar/SocketStatsBar';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { useEffect } from 'react';
import { SymplifyState } from 'src/domains/layouts/state/symplify/SymplifyState';
import { AppInner } from './uiApp';
import { ssrReactLazy } from 'src_common/common/mobx-utils/ResourceSSR';

const DebugPanel = ssrReactLazy(
    async () => (await import('src/domains/layouts/webview/components/debugPanel/DebugPanel')).DebugPanel
);

export const App = observer('App', () => {
    const common = useCommon();

    const starRouter = StarRouter.get(common);
    const { currentView } = starRouter;

    const env = EnvironmentState.get(common);

    useEffect(() => {
        SymplifyState.get(common).initCarmaRoi();
    }, []);

    return (
        <>
            <GlobalWrapper
                theme={env.emotionTheme}
                currentView={currentView}
            />
            <AppInner />
            <SocketStatsBar />
            <React.Suspense fallback={null}>
                <DebugPanel currentView={currentView} />
            </React.Suspense>
        </>
    );
});
